"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionList = void 0;
var react_1 = __importStar(require("react"));
require("../../../index.css");
var SectionList = /** @class */function (_super) {
  __extends(SectionList, _super);
  function SectionList() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.renderSectionContent = function () {
      var _a;
      var sectionView = [];
      (_a = _this.props.sectionContent) === null || _a === void 0 ? void 0 : _a.map(function (eachContent, index) {
        sectionView.push(react_1.default.createElement("div", {
          className: "border-t-2 border-gray-100 pt-6",
          key: index
        }, react_1.default.createElement("dt", {
          className: "text-base font-medium text-gray-500"
        }, eachContent.title), react_1.default.createElement("dd", {
          className: "text-xl font-extrabold tracking-tight text-gray-900 whitespace-nowrap overflow-ellipsis overflow-hidden"
        }, eachContent.content)));
        return null;
      });
      return sectionView;
    };
    return _this;
  }
  SectionList.prototype.render = function () {
    return react_1.default.createElement("dl", {
      className: "grid grid-cols-2 gap-x-4 gap-y-8"
    }, this.renderSectionContent());
  };
  return SectionList;
}(react_1.Component);
exports.SectionList = SectionList;